export default __webpack_public_path__ + "static/media/process_header.ad17b756.jpg";